import { render, staticRenderFns } from "./CreateStudioStudents.vue?vue&type=template&id=609fd34c&scoped=true"
import script from "./CreateStudioStudents.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateStudioStudents.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateStudioStudents.vue?vue&type=style&index=0&id=609fd34c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609fd34c",
  null
  
)

export default component.exports